export default __webpack_public_path__ + "static/media/Noodle Analytics, Inc..61d605cf.png";